var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.stringsStore.stringsLoaded)?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }